interface IVerificationDto {
  iban_ownership_verified: boolean;
  account_holder_name: string;
  verified: string;
}

class IBANVerificationResult implements IVerificationDto {
  iban_ownership_verified: boolean;
  account_holder_name: string;
  verified: string;

  constructor(data: Partial<IVerificationDto>) {
    this.iban_ownership_verified = data.iban_ownership_verified || false;
    this.account_holder_name = data.account_holder_name || '';
    this.verified = data.verified || '';
  }

  // from json to class
  static fromJson(json: any): IBANVerificationResult {
    return new IBANVerificationResult({
      iban_ownership_verified: json.iban_ownership_verified || false,
      account_holder_name: json.BenName || '',
      verified: json.Verified || '',
    });
  }

  // from class to json
  toJson(): IVerificationDto {
    return {
      iban_ownership_verified: this.iban_ownership_verified,
      account_holder_name: this.account_holder_name,
      verified: this.verified,
    };
  }
}

export default IBANVerificationResult;
